
import React, {useState, useEffect} from "react";
import { useLocation } from 'react-router-dom';
import { ORG_GET_KYC_DOCUMENTS_LIST,ORG_GET_USER_CREDENTIAL_LIST,ORG_CLIENT_BILLFEE_LIST, ORG_GET_CLIENT_TASK_LIST} from '../../../../ApiServices/BaseURL';
import { getData, postData } from "../../../../ApiServices/ApiService";
import { useTheme } from "../../../../GlobalContext/GlobalContext";
import { logFrontendException } from "../../../../Utils/Exception";

const ManageClientController =(clientId)=>{
    const [kycListLoading, setKycListLoading] = useState(false);
    const [kycListError, setKYCListError] = useState('');
    const [success, setSuccess] = useState('');
    const [kycDocumentList, setKycDocumentList] = useState([]);
    const [userCredentials, setUserCredentials] = useState([]);
    const [userCredentialLoading, setUserCredentialLoading] = useState(false);
    const [userCredentailError, setUserCredentailError] = useState("");
    const { setIsLoginPopup } = useTheme();
    const [taskList, setTaskList] = useState([]);
    const [taskListLoading,setTaskListLoading]=useState(false);
    const [taskListError,setTaskListError]=useState('');
    const [oneTimeUseEffectCallForChiled,setOneTimeUseEffectCallForChiled] = useState(true);

    const [billFeeListLoading, setbillFeeListLoading] = useState(false);
    const [billFeeListError, setbillFeeListError] = useState('');
    const [billFeeList, setbillFeeList] = useState([]);

     const pageName = 'manageClientController';
  const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;

    useEffect(()=>{
        fetchKYCDocumentsList();
        fetchUserCredentials();
        fetchClientTaskList();
        fetchBillFeeList();
    },[clientId])

    const fetchUserCredentials = async () => {
      //console.log('Fetching user credentials');
      try {
          setUserCredentials([]); // Reset credentials list
          setUserCredentialLoading(true); // Start loading
          setUserCredentailError(''); // Clear any existing error

          const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

          // Make the API call
          const response = await getData(`${ORG_GET_USER_CREDENTIAL_LIST}?emp_id_auth=${storedUserInfo?.emp_id}&client_id=${clientId}`);
          const responseData = await response.json();

          // Check for success (200) and internal status code
          if (response?.status === 200) {
              if (responseData?.statusCode === 200) {
                  if (responseData?.message.toLowerCase() === 'success') {
                      if (responseData?.dataJ?.length > 0) {
                          const accounts = responseData?.dataJ || [];
                          const formattedCredentials = accounts.map((account) => ({
                              portalName: account.account_name,
                              username: account.account_user_name,
                              password: account.account_user_password,
                              showPassword: false,
                              url: account.account_web_url,
                              account_id: account.account_id,
                          }));
                          setUserCredentials(formattedCredentials); // Update credentials
                      } else {
                          setUserCredentailError(responseData?.info || 'No credentials found.');
                          logFrontendException(storedUserId, pageName, "fetchUserCredentials", responseData?.info || '');
                      }
                  } else {
                      setUserCredentailError(responseData?.info || 'Failed to fetch credentials.');
                      logFrontendException(storedUserId, pageName, "fetchUserCredentials", responseData?.info || '');
                  }
              } else {
                  setUserCredentailError(responseData?.info || 'Failed to fetch credentials.');
                  logFrontendException(storedUserId, pageName, "fetchUserCredentials", responseData?.info || '');
              }
          }
          // Handle specific token-related errors
          else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
              setUserCredentailError('Unauthorized access. Your session may have expired. Please log in again.');
              logFrontendException(storedUserId, pageName, "fetchUserCredentials", responseData || '');
              setIsLoginPopup(true)
          }
          else {
              setUserCredentailError('Failed to fetch credentials. Please check your network connection and try again!');
              logFrontendException(storedUserId, pageName, "fetchUserCredentials", responseData || '');
          }
      } catch (error) {
            setUserCredentailError(`Failed to fetch credentials. Please check your network connection and try again.`);
            logFrontendException(storedUserId, pageName, "fetchUserCredentials-catch", error || '');
         
      } finally {
          setUserCredentialLoading(false); // Stop loading
      }
  };

    const fetchKYCDocumentsList =async ()=>{
        try {
          setKycDocumentList([]);
            setKycListLoading(true);
            setKYCListError('');
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
        
            // Make the API call
            const response = await getData(`${ORG_GET_KYC_DOCUMENTS_LIST}?emp_id_auth=${storedUserInfo?.emp_id}&client_id=${clientId}`);
            const responseData = await response.json();
        
            // Check for success (200) and internal status code
            if (response?.status === 200) {
              if (responseData?.statusCode === 200) {
                if (responseData?.message.toLowerCase() === 'success') {
                  if (responseData?.dataJ?.length > 0) {
                    setKycDocumentList(responseData?.dataJ);
                  } else {
                    setKYCListError(responseData?.info || 'Data Not Found');
                    logFrontendException(storedUserId, pageName, "fetchKYCDocumentsList", responseData?.info || '');
                  }
                } else {
                    setKYCListError(responseData?.info || 'Failed to fetch KYC documents. Please try again.');
                    logFrontendException(storedUserId, pageName, "fetchKYCDocumentsList", responseData?.info || '');
                }
              } else {
                setKYCListError(responseData?.info || 'Failed to fetch KYC documents.');
                logFrontendException(storedUserId, pageName, "fetchKYCDocumentsList", responseData?.info || '');
              }
            } 
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                setKYCListError(responseData?.info || 'Bad request. Please check the request parameters.')
                logFrontendException(storedUserId, pageName, "fetchKYCDocumentsList", responseData || '');
                setIsLoginPopup(true)
            } 
            else {
                setKYCListError('Failed to fetch KYC documents. Please try again later.');
                logFrontendException(storedUserId, pageName, "fetchKYCDocumentsList", responseData || '');
            }
          } catch (error) {
        
              setKYCListError(`Failed to fetch KYC documents. Please check your network connection and try again.`);
              logFrontendException(storedUserId, pageName, "fetchKYCDocumentsList-catch", error || '');
            
          } finally {
            setKycListLoading(false);
          }
      }

      const fetchClientTaskList = async () => {
        try {
          setTaskList([]); // Reset credentials list
          setTaskListLoading(true); // Start loading
          setTaskListError(''); // Clear any existing error
  
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
  
            // Make the API call
            const response = await getData(`${ORG_GET_CLIENT_TASK_LIST}?emp_id_auth=${storedUserInfo?.emp_id}&client_id=${clientId}`);
            const responseData = await response.json();
  
            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ?.length > 0) {                            
                          setTaskList(responseData?.dataJ); 
                        } else {
                          setTaskListError(responseData?.info || 'No data found.');
                          logFrontendException(storedUserId, pageName, "fetchClientTaskList", responseData?.info || '');
                        }
                    } else {
                      setTaskListError(responseData?.info || 'Failed to fetch task list.');
                       logFrontendException(storedUserId, pageName, "fetchClientTaskList", responseData?.info || '');
                    }
                } else {
                  setTaskListError(responseData?.info || 'Failed to fetch task list.');
                   logFrontendException(storedUserId, pageName, "fetchClientTaskList", responseData?.info || '');
                }
            }
            // Handle specific token-related errors
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
               setTaskListError('Unauthorized access. Your session may have expired. Please log in again.');
                logFrontendException(storedUserId, pageName, "fetchClientTaskList", responseData || '');
                setIsLoginPopup(true)
              
            }
            else {
              setTaskListError('Failed to fetch task list. Please try again later.');
               logFrontendException(storedUserId, pageName, "fetchClientTaskList", responseData || '');
            }
        } catch (error) {
        
              setTaskListError(`Failed to fetch task list. Please check your network connection and try again.`);
               logFrontendException(storedUserId, pageName, "fetchClientTaskList-catch", error || '');
            
        } finally {
            setTaskListLoading(false)
        }
    };

      const fetchKYCDocumentsRefresh =()=>{
        //console.log('call the refresh')
        fetchKYCDocumentsList();
      }

      const fetchBillFeeList = async () => {
        try {
          setbillFeeList([]); // Reset credentials list
          setbillFeeListLoading(true); // Start loading
          setbillFeeListError(''); // Clear any existing error
  
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payLoad ={
              "emp_id_auth": storedUserInfo?.emp_id,
              "client_id": clientId
            }
  
            // Make the API call
            // const response = await getData(`${ORG_CLIENT_BILLFEE_LIST}?emp_id_auth=${storedUserInfo?.emp_id}&client_id=${clientId}`);
            const response = await postData(ORG_CLIENT_BILLFEE_LIST,payLoad)
            const responseData = await response.json();
  
            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ?.length > 0) {                            
                          setbillFeeList(responseData?.dataJ); 
                        } else {
                          setbillFeeListError(responseData?.info || 'No data found.');
                           logFrontendException(storedUserId, pageName, "fetchBillFeeList", responseData?.info || '');
                        }
                    } else {
                      setbillFeeListError(responseData?.info || 'Failed to fetch bill and fee list.');
                      logFrontendException(storedUserId, pageName, "fetchBillFeeList", responseData?.info || '');
                    }
                } else {
                  setbillFeeListError(responseData?.info || 'Failed to fetch bill and fee list.');
                  logFrontendException(storedUserId, pageName, "fetchBillFeeList", responseData?.info || '');
                }
            }
            // Handle specific token-related errors
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
              setbillFeeListError('Unauthorized access. Your session may have expired. Please log in again.');
              logFrontendException(storedUserId, pageName, "fetchBillFeeList", responseData || '');
              setIsLoginPopup()
              
            }
            else {
              setbillFeeListError('Failed to fetch bill and fee list. Please try again later.')
              logFrontendException(storedUserId, pageName, "fetchBillFeeList", responseData || '');;
            }
        } catch (error) {
          setbillFeeListError(`Failed to fetch bill and fee list. Please check your network connection and try again.`);
          logFrontendException(storedUserId, pageName, "fetchBillFeeList-catch", error || '');
           
        } finally {
          setbillFeeListLoading(false)
        }
    };
    const fetchBillFeeRefresh =()=>{
      fetchBillFeeList();
    }
      return{
        kycListLoading,
        kycListError,
        kycDocumentList,
        fetchKYCDocumentsRefresh,
        userCredentials,
        userCredentialLoading,
        userCredentailError,
        fetchUserCredentials,
        setUserCredentials,
        taskList,
        taskListLoading,
        taskListError,
        fetchClientTaskList,
        oneTimeUseEffectCallForChiled,setOneTimeUseEffectCallForChiled,
        fetchBillFeeRefresh,billFeeList,billFeeListError,billFeeListLoading
      }
}

export default ManageClientController
